

import { Component, Input, OnInit } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import {
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
    FormBuilder,
} from "@angular/forms";
import { TypedFormGroup } from "src/app/shared-utils/typed-forms.helper";
import { ContractComment } from "src/app/core/models/contractComment";
import { ContractApiService } from "src/app/core/api/contract-api.service";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs";
import { QuillEditorComponent, QuillModules } from "ngx-quill";

@Component({
    selector: "app-create-contract-comments",
    standalone: true,
    imports: [
        TranslatePipe,
        FormsModule,
        ReactiveFormsModule,
        QuillEditorComponent,
    ],
    templateUrl: "./create-comment-modal.component.html",
    styleUrl: "./create-comment-modal.component.scss",
})
export class CreateCommentModalComponent implements OnInit {
    @Input() public contractId : number;
    public commentDataForm: TypedFormGroup<Partial<ContractComment>>;
    public currentAdminName: string;

    public modules: QuillModules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
        ],
    };


    constructor(
        private formBuilder: FormBuilder,
        public activeModal: NgbActiveModal,
        private contractApiService: ContractApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {}

    private buildform() {
        this.commentDataForm = this.formBuilder.group({
            id: [null],
            adminName: [""],
            comment: ["", [Validators.required]],
        }) as TypedFormGroup<Partial<ContractComment>>;
    }

    ngOnInit() {
        this.buildform();
    }

    onSave() {
        if (this.commentDataForm.invalid) {
            this.commentDataForm.markAllAsTouched();
            return;
        }
        if (this.contractId === 0) {
            return;
        }
        const formValue = this.commentDataForm.value
        const postContractCommentData: ContractComment = {
            id: formValue.id ?? 0,
            adminName: this.currentAdminName,
            comment: formValue.comment,
            contractId: this.contractId,
            createdAt: formValue.createdAt
        }

   this.contractApiService
            .createContractComment(postContractCommentData)
            .pipe(take(1))
            .subscribe({
                next: (response) => {
                    console.log({response})
                    this.activeModal.close(response);
                    this.translateService.get('contractComment.form.createdSuccess').subscribe((res:string) => {
                        this.toastrService.success(res)
                    })
                     this.activeModal.close(response);
                },
                error: () => {
                this.translateService.get('contractComment.form.createdError').subscribe((res: string) => {
                    this.toastrService.error(res);
                });
            }
            })
    }

    onClose() {
        this.activeModal.dismiss();
    }

}
